/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/rules-of-hooks */
import { useRecoilStateLoadable, useRecoilValueLoadable } from 'recoil';

import { agentUserId } from '../../../../recoil/atoms/agentUserId';
import { user } from '../../../../recoil/atoms/user';
export function BreadCrumbs({ items }) {
  if (!items || !items.length) {
    return '';
  }
  const userAtom = useRecoilValueLoadable(user);
  const loginUser = userAtom.contents?.user ?? {};
  const [agentUserIdAtom] = useRecoilStateLoadable(agentUserId);
  return (
    <ul className="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold p-0 my-2">
      <li className="breadcrumb-item">
        <i className="flaticon2-shelter text-muted icon-1x" />
      </li>
      {items.map((item, index) => (
        <li key={`bc${index}`} className="breadcrumb-item">
          {item.title === 'My Profile' ? (
            <span className="text-muted">My Profile</span>
          ) : null}
          {item.title === 'Manage' ? (
            <span className="text-muted">Manage</span>
          ) : null}
          {item.title === 'Reporting' ? (
            <span className="text-muted">Reporting</span>
          ) : null}

          {item.title === 'Agent Settings' ||
          item.title === 'Inbound Call Flow' ||
          item.title === 'My PowerLists' ||
          item.title === 'SMS Template' ||
          item.title === 'VM Drop' ||
          ((window.location.pathname ===
            `/my-profile/${loginUser.userid}/numbers` ||
            window.location.pathname ===
              `/manage/agents/${agentUserIdAtom.contents.id}/numbers`) &&
            item.title === 'Numbers') ? (
            <>
              <span className="text-muted breadcrumb-item">Profile</span>
              <span className="text-muted">&nbsp;&nbsp;{item.title}</span>
            </>
          ) : null}
          {item.title === 'Agent Snapshot' ||
          (item.title === 'Call History' &&
            window.location.pathname ===
              `/my-profile/${loginUser.userid}/call-history`) ||
          (item.title === 'My Agent Summary' &&
            window.location.pathname ===
              `/my-profile/${loginUser.userid}/agent-reporting`) ||
          (item.title === 'SMS History' &&
            window.location.pathname ===
              `/my-profile/${loginUser.userid}/sms-history`) ||
          (item.title === 'Call History' &&
            window.location.pathname ===
              `/manage/agents/${agentUserIdAtom.contents.id}/call-history`) ||
          (item.title === 'Reporting' &&
            window.location.pathname ===
              `/manage/agents/${agentUserIdAtom.contents.id}/agent-reporting`) ||
          (item.title === 'SMS History' &&
            window.location.pathname ===
              `/manage/agents/${agentUserIdAtom.contents.id}/sms-history`) ? (
            <>
              <span className="text-muted breadcrumb-item">Reporting</span>
              <span className="text-muted">&nbsp;&nbsp;{item.title}</span>
            </>
          ) : null}
          {item.title === 'Webhooks' || item.title === 'Cadences' ? (
            <>
              <span className="text-muted breadcrumb-item">Automations</span>
              <span className="text-muted">&nbsp;&nbsp;{item.title}</span>
            </>
          ) : null}
          {item.title === 'Conferences' ||
          item.title === 'Inbound Routing' ||
          item.title === 'IVRs' ||
          item.title === 'Queues' ||
          item.title === 'Ring Groups' ? (
            <>
              <span className="text-muted breadcrumb-item">Inbound</span>
              <span className="text-muted">&nbsp;&nbsp;{item.title}</span>
            </>
          ) : null}
          {item.title.startsWith('Agent ') &&
          !(
            window.location.pathname ===
              `/my-profile/${loginUser.userid}/edit` ||
            window.location.pathname ===
              `/manage/agents/${agentUserIdAtom.contents.id}/edit` ||
            window.location.pathname.endsWith('edit') ||
            item.title.endsWith('Snapshot')
          ) ? (
            <span className="text-muted">{item.title}</span>
          ) : null}
          {!(
            item.title === 'My Profile' ||
            item.title === 'Manage' ||
            (item.title.startsWith('Agent ') &&
              !(
                window.location.pathname ===
                `/manage/agents/${agentUserIdAtom.contents.id}/edit`
              )) ||
            item.title === 'Agent Settings' ||
            item.title === 'Webhooks' ||
            item.title === 'Cadences' ||
            item.title === 'Conferences' ||
            item.title === 'Inbound Routing' ||
            item.title === 'IVRs' ||
            item.title === 'Queues' ||
            item.title === 'Ring Groups' ||
            item.title === 'Inbound Call Flow' ||
            item.title === 'My PowerLists' ||
            item.title === 'SMS Template' ||
            item.title === 'VM Drop' ||
            (item.title === 'Numbers' &&
              window.location.pathname ===
                `/my-profile/${loginUser.userid}/numbers`) ||
            (item.title === 'Numbers' &&
              window.location.pathname ===
                `/manage/agents/${agentUserIdAtom.contents.id}/numbers`) ||
            (item.title === 'Agent Snapshot' &&
              window.location.pathname ===
                `/manage/agents/${agentUserIdAtom.contents.id}/agent-snapshot`) ||
            (item.title === 'Call History' &&
              window.location.pathname ===
                `/my-profile/${loginUser.userid}/call-history`) ||
            (item.title === 'Call History' &&
              window.location.pathname ===
                `/manage/agents/${agentUserIdAtom.contents.id}/call-history`) ||
            (item.title === 'My Agent Summary' &&
              window.location.pathname ===
                `/my-profile/${loginUser.userid}/agent-reporting`) ||
            (item.title === 'Reporting' &&
              window.location.pathname ===
                `/manage/agents/${agentUserIdAtom.contents.id}/agent-reporting`) ||
            (item.title === 'SMS History' &&
              window.location.pathname ===
                `/my-profile/${loginUser.userid}/sms-history`) ||
            (item.title === 'SMS History' &&
              window.location.pathname ===
                `/manage/agents/${agentUserIdAtom.contents.id}/sms-history`) ||
            item.title === 'Reporting'
          ) && <span className="text-muted">{item.title}</span>}
        </li>
      ))}
    </ul>
  );
}
